import { FILE_TYPE } from "@/schemas/question/file-types";
import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import EnumSelect from "@/components/EnumSelect";

const FileTypeSelect = forwardRef<HTMLButtonElement, ControllerRenderProps>(
  (props, ref) => (
    <EnumSelect
      options={FILE_TYPE}
      translationKey="fileTypes"
      {...props}
      ref={ref}
    />
  ),
);

export default FileTypeSelect;
